export const NUMBER_OF_PREVIEW_ROWS = 10;



// WEBPACK FOOTER //
// ./src/pages/importstudents/helpers/Constants.js